import { configureStore } from "@reduxjs/toolkit";
import { apiSlice } from "../Components/Features/api/apiSlice";
import authSliceReducer from "../Components/Features/auth/authSlice";
import filter from "../Components/Features/filter/filter";
import UserSlice from "../Components/Features/users/UserSlice";

export const store = configureStore({
    reducer: {
        [apiSlice.reducerPath]: apiSlice.reducer,
        auth: authSliceReducer,
        users: UserSlice,
        filter: filter,
    },
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddlewares) =>
        getDefaultMiddlewares().concat(apiSlice.middleware),
});
